import { useCallback, useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import { PropagateLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import Card from "../../atoms/Card";
import Heading from "../../atoms/Heading";
import IconButton from "../../atoms/IconButton";
import CardHeader from "../../atoms/CardHeader";
import HipotecaTable from "../../organisms/inmueble/inmuebleDocsTables/HipotecaTable";
import ArchivosRentaTable from "../../organisms/inmueble/inmuebleDocsTables/ArchivosRentaTable";
import ArchivoPermanenteTable from "../../organisms/inmueble/inmuebleDocsTables/ArchivoPermanenteTable";
import { GET_INMUEBLE_ID } from "../../../api/apiInmuebles";
import { GET_ARCHIVO_PERMAMENTE, GET_HIPOTECA, GET_MANTENIMIENTO_BY_PROPERTIE, GET_RENTA_ARCHIVOS } from "../../../api/apiFiles";
import MantenimientoInmuebleTable from "../../organisms/inmueble/inmuebleDocsTables/mantenimiento/MantenimientoInmuebleTable";
import { GET_AIRBNB_BY_PROPERTIE } from "../../../api/apiAirbnb";
import AirbnbTable from "../../organisms/inmueble/inmuebleDocsTables/airbnb/AirbnbTable";
import Breadcrumb from "../../molecules/Breadcrumb";
import { getInmobiliaria } from "../../../utils/getInmobiliaria";

const InmuebleDocTemplate = () => {
    const { id, im, table } = useParams();
    const [loading, setLoading] = useState(true);
    const [inmueble, setInmueble] = useState();
    const [documentos, setDocumentos] = useState();

    const fetchDocumentos = useCallback (async (tabla) => {
        const fetchFunctions = {
            archivo_permanente: GET_ARCHIVO_PERMAMENTE,
            hipoteca: GET_HIPOTECA,
            archivos_renta: GET_RENTA_ARCHIVOS,
            mantenimiento: GET_MANTENIMIENTO_BY_PROPERTIE,
            airbnb: GET_AIRBNB_BY_PROPERTIE,
        };

        const fn = typeof fetchFunctions[tabla] === "function" && fetchFunctions[tabla];

        if (fn) {
            try {
                const response = await fn(Number(im));
                setDocumentos(response);
            } catch (error) {
                console.error(error);
            }
        }
    }, [im]);

    const getInmueble = useCallback ( async () => {
        if (!im) return;
        try {
                const inmuebleData = await GET_INMUEBLE_ID(Number(im));
                setInmueble(inmuebleData);
                await fetchDocumentos(table);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        }, [fetchDocumentos, im, table]);

    useEffect(() => {
        if (!im || !table) return;
        getInmueble();
    },[getInmueble, im, table]);

    const tables = [
        { text: "Archivo permanente", route:"archivo_permanente", },
        { text: "Hipoteca", route:"hipoteca", },
        { text: "Archivos de renta", route:"archivos_renta", },
        { text: "Mantenimiento", route:"mantenimiento", },
        { text: "Airbnb", route:"airbnb", },
    ];

    const getTableName = (table) => {
        const found = tables.find(t => t.route === table);
        return found ? found.text : "Tabla desconocida";
    };

    const renderTable = () => {
        switch (table) {
            case "archivo_permanente": return <ArchivoPermanenteTable data={documentos} loading={loading} refetch={getInmueble} />;
            case "hipoteca": return <HipotecaTable data={documentos} loading={loading} refetch={getInmueble} />;
            case "archivos_renta": return <ArchivosRentaTable data={documentos} loading={loading} refetch={getInmueble} />;
            case "mantenimiento": return <MantenimientoInmuebleTable data={documentos} loading={loading} refetch={getInmueble} />;
            case "airbnb": return <AirbnbTable data={documentos} loading={loading} refetch={getInmueble} />;
            default: return <p> No hay tabla para mostrar </p>;
        }
    };

    if (loading) return <div className="w-full h-screen flex items-center justify-center"> <PropagateLoader color="red"/> </div>;

    return (
        <div className="flex flex-col gap-4">
            {inmueble ?
                <>
                    <CardHeader
                          left={
                            <Breadcrumb
                              items={[
                                { label: "Inmobiliarias", to: "/inmobiliarias" },
                                { label: getInmobiliaria(id), to: `/inmobiliarias/${id}` },
                                { label: inmueble?.name, to: `/inmobiliarias/${id}/${im}` },
                                { label: getTableName(table), to: null },
                              ]}
                            />
                          }
                        right={<IconButton icon={FaPlus} bgColor="bg-white" disabled/>}
                    />
                    <Card>
                        {renderTable()}
                    </Card>
                </>
            :
                <Heading text="Error al obtener el inmueble intente mas tarde y/o contacte con soporte tecnico" />
            }
        </div>
    );
};

export default InmuebleDocTemplate;